import React, { Fragment } from "react";
import Navbar from "../../Components/Navbar";
import OutlookEvent from "../../Pages/Benefits/outlookEvent";
import HolidayCalendarSc from "./index.sc";
function Index() {
  const Holiday = [
    { Holiday: "New year's Day", Date: "01/Jan/2025", Day: "Wednesday" },
    { Holiday: "Pongal Holiday", Date: "14/Jan/2025", Day: "Tuesday" },
    { Holiday: "Republic Day", Date: "27/Jan/2025", Day: "Monday" },
    { Holiday: "Eid-ul-Fltr", Date: "31/Mar/2025", Day: "Monday" },
  
    { Holiday: "Bakrid", Date: "09/Jun/2025", Day: "Monday" },
    { Holiday: "Independence Day", Date: "15/Aug/2025", Day: "Friday" },
    { Holiday: "Ganesh Chathurthi", Date: "27/Aug/2025", Day: "Wednesday" },
    { Holiday: "Gandhi Jayanthi/Vijayadashami", Date: "02/Oct/2025", Day: "Thursday" },
    { Holiday: "Diwali", Date: "20/Oct/2025", Day: "Monday" },
    { Holiday: "Christmas", Date: "25/Dec/2025", Day: "Thursday" },
  ];
  return (
    <>
    
    <HolidayCalendarSc>
     <OutlookEvent />
      {/* <h1>Happy Holidays :)</h1> */}
      <table>
        <tr>
          <th>Holiday</th>
          <th>Date</th>
          <th>Day</th>
        </tr>
        {Holiday?.map((data, idx) => {
          return (
            <Fragment key={idx}>
              <tr>
                <td>{data?.Holiday}</td>
                <td>{data?.Date}</td>
                <td>{data?.Day}</td>
              </tr>
            </Fragment>
          );
        })}
      </table>
    </HolidayCalendarSc>
    </>
  );
}

export default Index;
